var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFieldArrowsXl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1477.38 933.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        isolation: isolate;\n        opacity: .4;\n        stroke: #53ab83;\n        stroke-width: 3px;\n      }\n\n      .cls-7 {\n        fill: #808285;\n      }\n\n      .cls-8 {\n        fill: #757678;\n      }\n\n      .cls-3 {\n        stroke: #808285;\n      }\n\n      .cls-3, .cls-4 {\n        stroke-width: 5px;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: #757678;\n      }\n\n      .cls-5 {\n        stroke-width: 4px;\n      }\n\n      .cls-9 {\n        opacity: .3;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 883.19,
    y: 669.24,
    width: 230,
    height: 178
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1475.88,756.67h-245.67V176.8h245.67M738.69,931.97V1.5m737.19,599.61h-79.27V332.36h79.27m-245.7,26.95c-32.91,24.47-54.21,63.48-54.21,107.43s21.3,82.96,54.21,107.43m211.44,357.81c0-18.78,15.33-33.99,34.25-33.99m0-862.49c-18.92,0-34.25-15.21-34.25-33.99M1.5,756.67H247.17V176.8H1.5m0,424.31H80.77V332.36H1.5m245.7,241.81c32.91-24.47,54.21-63.48,54.21-107.43s-21.3-82.96-54.21-107.43M35.76,931.97c0-18.78-15.33-33.99-34.25-33.99M1.51,35.49c18.93,0,34.26-15.21,34.26-33.99M873.87,466.74c0,74.09-60.52,134.15-135.18,134.15s-135.18-60.06-135.18-134.15,60.52-134.15,135.18-134.15,135.18,60.06,135.18,134.15Zm602.01,465.24H1.5V1.5H1475.88V931.97Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M922.67,78.39c6.79,3.01,14.76-.07,17.76-6.85,1.22-2.75,1.42-5.7,.8-8.43,39.95-11.82,80.15,23.84,119.16,58.45,22.75,20.19,44.73,39.7,65.92,49.08,12.11,5.37,23.96,7.42,35.54,4.4l-4.07,8.35,4.19,2.04,7.5-15.38-15.89-6.35-1.73,4.33,7.18,2.87c-29.06,6.15-61.42-22.55-95.55-52.83-40.2-35.67-81.65-72.43-124.07-59.31-1.37-2.13-3.35-3.89-5.83-4.99-6.79-3.01-14.76,.07-17.76,6.85-3.01,6.79,.07,14.76,6.85,17.76Zm9.02-20.35c4.44,1.97,6.45,7.18,4.48,11.61-1.97,4.44-7.18,6.45-11.61,4.48s-6.45-7.18-4.48-11.61c1.97-4.44,7.18-6.45,11.61-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1147.42,528.86c-152.02-58.82-163.94-128.87-259.33-129.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1145.89,528.92l-9.86,4.01,1.69,4.14,14.3-5.81-6.81-13.84-4.01,1.97,4.69,9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M874.02,411.11c5.88,1.52,12.03-1.97,13.73-7.81,1.7-5.83-1.69-11.79-7.57-13.32-5.88-1.52-12.03,1.97-13.73,7.81-1.7,5.83,1.69,11.79,7.57,13.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M548.19,286.24l22.65,23.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M570.5,286.72l-22.15,22.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M906.34,303.27l1.6,5.28,15.01-4.54-1.6-5.28-15.01,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1003.66,273.27l1.6,5.28,15.01-4.54-1.6-5.28-15.01,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M931.07,295.78l1.6,5.28,15.01-4.54-1.6-5.28-15.01,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1028.39,265.78l1.6,5.28,15.01-4.54-1.6-5.28-15.01,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M881.6,310.75l1.6,5.28,15.01-4.54-1.6-5.28-15.01,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M978.93,280.75l1.6,5.28,15.01-4.54-1.6-5.28-15.01,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M856.87,318.24l1.6,5.28,15.01-4.54-1.6-5.28-15.01,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M954.19,288.24l1.6,5.28,15.01-4.54-1.6-5.28-15.01,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M807.4,333.21l1.6,5.28,15.01-4.54-1.6-5.28-15.01,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M832.13,325.73l1.6,5.28,15.01-4.54-1.6-5.28-15.01,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M790.16,338.43l1.6,5.28,7.51-2.27-1.6-5.28-7.51,2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M773.18,346.45l18.19,8.89,2.42-4.95-12.86-6.29,7.21-12.36-4.76-2.78-10.2,17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M292.26,499.21l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M373.5,606.74l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M385.1,622.1l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M904.47,831.84l-4.2-1.73-3.15,7.62c-16.1-49.06,.24-101.82,42.55-135.78,43.23-34.7,102.6-37.59,148.54-8.5-.82,1.7-1.29,3.6-1.29,5.62,0,7.22,5.89,13.1,13.13,13.1s13.14-5.88,13.14-13.1-5.89-13.1-13.14-13.1c-3.6,0-6.86,1.45-9.23,3.8-21.1-13.3-45.86-20.53-71.03-20.53-30.05,0-59.52,10.37-82.97,29.19-43.94,35.27-60.82,90.16-43.89,141.15l-7.71-3.85-2.03,4.05,14.92,7.45,6.36-15.39h0Zm195.59-141.34c4.73,0,8.59,3.84,8.59,8.56s-3.85,8.56-8.59,8.56-8.58-3.84-8.58-8.56,3.85-8.56,8.58-8.56Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M396.71,637.46l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M361.89,591.38l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M327.07,545.29l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M338.68,560.65l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M303.86,514.57l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.28,576.02l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M454.73,714.26l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M315.47,529.93l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M443.13,698.9l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M419.92,668.18l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M408.31,652.82l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M431.52,683.54l-4.1,2.6,6.98,9.23,4.1-2.6-6.98-9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M466.49,754.73l4.19,1.22c1.97-3.48,2.98-7.27,2.9-10.95l-4.72,.78c.06,3.01-.75,6.11-2.36,8.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M447.27,770.77l.23-4.02c-3.47,.38-6.92-.01-9.98-1.13l-2.47,3.77c3.73,1.36,7.95,1.84,12.21,1.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M404.16,726.27l-4.1,2.6,6.67,8.83,4.1-2.6-6.67-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M415.16,740.82l-4.1,2.6,6.67,8.83,4.1-2.6-6.67-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M393.17,711.71l-4.1,2.6,6.67,8.83,4.1-2.6-6.67-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M382.17,697.15l-4.1,2.6,6.67,8.83,4.1-2.6-6.67-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M360.18,668.04l-4.1,2.6,6.67,8.83,4.1-2.6-6.67-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M371.17,682.6l-4.1,2.6,6.67,8.83,4.1-2.6-6.67-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M352.51,657.9l-4.1,2.6,3.34,4.42,4.1-2.6-3.34-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M425.39,762.39c1.07,1.41,2.33,2.68,3.76,3.79l3.49-3.22c-1.19-.92-2.25-1.98-3.14-3.17l-3.34-4.41-4.1,2.6,3.34,4.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M465.73,736.84c.89,1.18,1.61,2.46,2.12,3.81l4.52-1.85c-.62-1.61-1.48-3.15-2.54-4.56l-3.49-4.62-4.1,2.6,3.49,4.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M462.76,759.52c-2.48,2.42-5.7,4.46-9.04,5.73l1.23,3.66c2.06-.78,4.07-1.79,5.96-2.98,1.89-1.2,3.63-2.57,5.15-4.06l-3.31-2.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M342.56,648.74l-3.93,14.85,4.6,.21,2.78-10.49,11.7,1.32,1.41-4.02-16.56-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.81,486.1c5.49-3.48,7.39-9.67,4.25-13.83-3.14-4.16-10.14-4.71-15.63-1.24-5.49,3.48-7.39,9.67-4.25,13.83,3.14,4.16,10.14,4.71,15.63,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.67,102.62l.61-7.67-4.14-.33-1.21,15.2,15.25,.09,.02-4.15-7.76-.04c28.56-25.97,66.56-38.71,105.07-35.05,75.23,7.16,130.59,74.35,123.42,149.77-3.39,35.65-20.74,68.75-47.9,91.83-1.74-1.35-3.86-2.25-6.21-2.48-6.59-.63-12.45,4.22-13.08,10.81-.63,6.59,4.22,12.45,10.81,13.08,6.59,.63,12.45-4.22,13.08-10.81,.26-2.74-.44-5.36-1.81-7.52,27.91-23.78,45.75-57.84,49.24-94.52,7.4-77.7-49.65-146.92-127.16-154.29-39.67-3.78-78.81,9.35-108.24,36.09Zm183.82,219.86c-.41,4.31-4.25,7.47-8.55,7.06-4.31-.41-7.48-4.24-7.07-8.55,.41-4.3,4.25-7.47,8.55-7.06,4.31,.41,7.48,4.25,7.07,8.55Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldArrowsXl);
export default __webpack_public_path__ + "static/media/field-arrows-XL.ee0f097df0c3cbe5dcf941b29fba4013.svg";
export { ForwardRef as ReactComponent };